import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { prescriptionQKeys } from "@hooks/queries/prescription/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Medication } from "@customTypes/prescription";


interface MutationProps {
  medication: Partial<Medication>;
  patientId: string;
}

export const useCreateMedication = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ medication }: MutationProps) => {
      return api.post("medication/", {
        ...medication,
        medication_name: medication.name,
        prescription_id: medication.prescriptionId,
      });
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "create-medication-success",
      });
      queryClient.invalidateQueries(
        prescriptionQKeys.medication(
          variables.medication.prescriptionId as string
        )
      );
      queryClient.invalidateQueries(
        prescriptionQKeys.patient(variables.patientId)
      );
    },

    onError: (res: any) => {
      console.error("[From Create Medication]", res);

      handleErrors(res, "mutation");
    },
  });
};
